import * as CodeDaleTheme from "@CodeDaleTheme/global";
import { eventModal } from "@CodeDaleTheme/modal";

if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        if (!this.hasAttribute("available")) return;
        // Cache the fallback error markup from the inline <template> for retry rendering.
        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            // Parse the fetched section markup and hand its root element to the renderer.
            const sectionElement = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionElement);
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList
        );
      }

      renderPreview(sectionElement) {
        // Remove any existing drawer before mounting the freshly fetched one.
        const drawer = document.querySelector(".pickup-availability-drawer");
        if (drawer) drawer.remove();
        // No preview in the response means the variant has no pickup availability.
        if (!sectionElement.querySelector(".pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }
        this.innerHTML = sectionElement.querySelector(
          "pickup-availability-preview"
        ).outerHTML;
        this.setAttribute("available", "");
        document.body.appendChild(
          sectionElement.querySelector(".pickup-availability-drawer")
        );
        const button = this.querySelector("button");
        setTimeout(() => {
          if (button) {
            button.addEventListener("click", (evt) => {
              document.querySelector("pickup-availability-drawer").show();
              CodeDaleTheme.global.rootToFocus = button;
            });
          }
        }, 800);
      }
    }
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();
      }

      show() {
        eventModal(this, "open");
      }
    }
  );
}
